<template>
  <MapModal
    class="newModelPosition hierarchy2"
    :modalNode="modalNode"
    :submitData="submitData"
    :submit="submit"
    :close="close"
    :title="cutTitle"
    id="addTrafficSimulation"
  >
  </MapModal>
</template>
<script>
const MapModal = () => import("@/components/common/mapModal/Index");

//按需加载
import {
  getDropDownList,
  postBimModeSlicedAdd,
  postBimModeSlicedEdit,
} from "@/api/api";
import _ from "lodash";
import * as mapWork from "./map.js";
export default {
  name: "cut-add",
  components: { MapModal },
  props: ["editData", "selectedScene", "cutType"],
  data() {
    return {
      show: false,
      data: [],
      cutTitle: "新增方案",

      modalNode: {
        cutAdd: {
          show: true, // 默认展示
          loading: false, // 加载loading
          // offset: {
          //   // 默认弹出层偏移
          //   x: 80,
          //   y: -750,
          // },
          height: "auto", // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
          // 模态框中心配置
          content: {
            type: "form",
            formData: {
              name: {
                md: 24,
                type: "input",
                title: "名称",
                placeholder: "请输入",
              },
              cutModel: {
                type: "cascader",
                title: "选择模型",
                placeholder: "选择模型",
                multiple: false,
                show: false,
                change: this.cutModelChange,
                options: [],
              },
              cutType: {
                md: 24,
                type: "radio",
                title: "选择剖切类",
                disabled: false,
                selectCreate: true,
                show: true,
                input: this.cutTypeChange,
                options: [
                  {
                    name: "面剖切",
                    id: 1,
                  },
                  {
                    name: "体剖切",
                    id: 2,
                  },
                ],
              },
              cutPosition: {
                md: 24,
                type: "button",
                show: true,
                title: "绘制",
                buttonTitle: "按面剖切",
                click: this.startCropping,
              },
              distance: {
                md: 24,
                type: "slider",
                title: "偏移距离",
                input: this.distanceInput,
                max: 100,
                min: -100,
                show: false,
              },
              normalz: {
                md: 24,
                type: "slider",
                title: "斜切偏移",
                input: this.normalzInput,
                step: 0.1,
                max: 10,
                min: -10,
                show: false,
              },
            },
            rules: {
              name: [
                {
                  required: true,
                  message: "请选择",
                  trigger: "blur",
                },
              ],
              // cutModel: [
              //   {
              //     required: true,
              //     message: "请选择",
              //     trigger: "blur",
              //   },
              // ],
              cutPosition: [
                {
                  required: true,
                  message: "请选择",
                  trigger: "blur",
                },
              ],
            },
          },
        },
      },
      projectId: window.sessionStorage.getItem("nowProjectId"),
      submitData: {
        name: null,
        cutModel: "[]",
        cutType: 1,
        cutPosition: null,
        distance: 0,
        normalz: 0,
        businessId: null,
        dataType: null,
      },
    };
  },
  computed: {
    //计算属性将被混入到 Vue 实例中。所有 getter 和 setter 的 this 上下文自动地绑定为 Vue 实例。
    //注意如果你为一个计算属性使用了箭头函数，则 this 不会指向这个组件的实例，不过你仍然可以将其实例作为函数的第一个参数来访问。
  },

  filters: {
    //包含 Vue 实例可用过滤器的哈希表。
  },
  beforeCreate() {
    //在实例初始化之后，数据观测 (data observer) 和 event/watcher 事件配置之前被调用。
  },
  created() {
    //在实例创建完成后被立即调用。在这一步，实例已完成以下的配置：数据观测 (data observer)，property 和方法的运算，watch/event 事件回调。然而，挂载阶段还没开始，el property 目前尚不可用。
  },
  beforeMount() {
    //在挂载开始之前被调用：相关的 render 函数首次被调用。
  },
  methods: {
    cutTypeChange(e) {
      mapWork.init();
      this.modalNode.cutAdd.content.formData.distance.show = false;
      this.modalNode.cutAdd.content.formData.normalz.show = false;
      if (e == 1) {
        this.modalNode.cutAdd.content.formData.cutPosition.buttonTitle =
          "按面剖切";
      } else {
        this.modalNode.cutAdd.content.formData.cutPosition.buttonTitle =
          "按体剖切";
      }
    },
    cutModelChange(e) {
      // mapWork.drawLine();
      if (e && e.length > 0) {
        // this.modalNode.cutAdd.content.formData.cutType.show = true;
        // this.modalNode.cutAdd.content.formData.cutPosition.show = true;
      } else {
        // this.modalNode.cutAdd.content.formData.cutType.show = false;
        // this.modalNode.cutAdd.content.formData.cutPosition.show = false;
      }
    },
    startCropping() {
      this.submitData.distance = 0;
      this.submitData.normalz = 0;
      if (this.submitData.cutType == 1) {
        // 面剖切
        mapWork.drawLine(this.submitData.cutModel, () => {
          if (mapWork.cutArrPositions.length > 0) {
            this.modalNode.cutAdd.content.formData.distance.show = true;
            this.modalNode.cutAdd.content.formData.normalz.show = true;
          } else {
            this.modalNode.cutAdd.content.formData.distance.show = false;
            this.modalNode.cutAdd.content.formData.normalz.show = false;
          }
          this.submitData.cutPosition = mapWork.cutArrPositions;
        });
      } else if (this.submitData.cutType == 2) {
        mapWork.drawPoly(this.submitData.cutModel, () => {
          if (mapWork.cutArrPositions.length) {
            this.modalNode.cutAdd.content.formData.distance.show = true;
          } else {
            this.modalNode.cutAdd.content.formData.distance.show = false;
          }
          this.modalNode.cutAdd.content.formData.normalz.show = false;
          this.submitData.cutPosition = mapWork.cutArrPositions;
          this.submitData.normalz = 0;
        });
      }
    },
    submit() {
      const commonParams = {
        projectId: window.sessionStorage.getItem("nowProjectId"),
        dataType: this.submitData.dataType || 2,
      };
      // console.log(this.selectedScene);
      // 根据 this.cutType 区分是新增还是编辑
      let request;
      if (this.cutType === "add") {
        request = postBimModeSlicedAdd({
          ...commonParams,
          businessId: this.selectedScene.id || "389001653039183",
          name: this.submitData.name,
          cutModel: this.submitData.cutModel,
          cutType: this.submitData.cutType,
          cutPosition: this.submitData.cutPosition,
          distance: this.submitData.distance,
          normalz: this.submitData.normalz,
        });
      } else {
        request = postBimModeSlicedEdit({
          ...commonParams,
          businessId: this.submitData.businessId,
          id: this.submitData.id,
          name: this.submitData.name,
          cutModel: this.submitData.cutModel,
          cutType: this.submitData.cutType,
          cutPosition: this.submitData.cutPosition,
          distance: this.submitData.distance,
          normalz: this.submitData.normalz,
        });
      }

      // 发送请求
      request
        .then((res) => {
          this.$emit("getList");
          this.close();
          this.$notify({
            title: this.cutType === "add" ? "保存成功" : "修改成功",
            message: "",
            type: "success",
            duration: 960,
            offset: 320,
          });
        })
        .catch((error) => {
          console.log(error);
          this.$notify({
            title: this.cutType === "add" ? "保存失败" : "修改失败",
            message: "",
            type: "error",
            duration: 960,
            offset: 320,
          });
        });
    },
    close() {
      mapWork.init();
      this.$emit("close");
    },
    deleteEmptyChildren(data) {
      if (data && data.length > 0) {
        data.forEach((item, index) => {
          if (item.children?.length == 0 && item.id != "-1") {
            delete item.children;
          } else {
            this.deleteEmptyChildren(item.children);
          }
        });
      }
      return data;
    },
    distanceInput(e) {
      // console.log(mapWork.renewDistance(e, this.submitData.normalz));
      this.submitData.cutPosition = mapWork.renewDistance(
        e,
        this.submitData.normalz
      );
      // mapWork.cutArrPositions
    },
    normalzInput(e) {
      mapWork.renewNormalz(e);
    },
    init() {
      mapWork.init();
      let params;
      if (this.cutType == "add") {
        params = {
          projectId: window.sessionStorage.getItem("nowProjectId"),
          scenesId: this.selectedScene.id,
        };
      } else {
        mapWork.editGraphicCutType("edit");
        mapWork.assemblyData(
          this.submitData.cutPosition,
          this.submitData.cutModel,
          this.submitData.id,
          this.submitData.normalz
        );
        params = {
          projectId: window.sessionStorage.getItem("nowProjectId"),
          scenesId: this.submitData.businessId,
        };
        // this.modalNode.cutAdd.content.formData.cutType.show = true;
        // this.modalNode.cutAdd.content.formData.cutPosition.show = true;
        this.modalNode.cutAdd.content.formData.distance.show = true;
        if (this.submitData.cutType == 1) {
          this.modalNode.cutAdd.content.formData.cutPosition.buttonTitle =
            "按面剖切";
          this.modalNode.cutAdd.content.formData.normalz.show = true;
        } else {
          this.modalNode.cutAdd.content.formData.cutPosition.buttonTitle =
            "按体剖切";
          this.modalNode.cutAdd.content.formData.normalz.show = false;
        }
      }
      getDropDownList(params).then((res) => {
        let { data } = res.data;
        this.modalNode.cutAdd.content.formData.cutModel.options =
          data[0].children.length > 0 ? this.deleteEmptyChildren(data) : data;
        console.log("模型树", res.data);
      });
    },
  },
  mounted() {
    // this.submitData = this.editData;
    // this.init();
  },
  destroyed() {
    mapWork.init();
  },
  watch: {
    editData(newVal, oldVal) {
      this.submitData = this.editData;
      this.init();
      this.cutTitle = "编辑方案";
    },
    cutType(newVal, oldVal) {
      if (newVal == "add") {
        this.cutTitle = "新增方案";
        getDropDownList({
          projectId: window.sessionStorage.getItem("nowProjectId"),
          scenesId: this.selectedScene.id,
        }).then((res) => {
          let { data } = res.data;
          this.modalNode.cutAdd.content.formData.cutModel.options =
            data[0].children.length > 0 ? this.deleteEmptyChildren(data) : data;
          console.log("模型树", res.data);
        });
        mapWork.init();
        this.submitData = {
          name: null,
          cutModel: "[]",
          cutType: 1,
          cutPosition: null,
          distance: 0,
          normalz: 0,
        };
        this.modalNode.cutAdd.content.formData.cutPosition.buttonTitle =
          "按面剖切";
        // this.modalNode.cutAdd.content.formData.cutType.show = false;
        // this.modalNode.cutAdd.content.formData.cutPosition.show = false;
        this.modalNode.cutAdd.content.formData.distance.show = false;
        this.modalNode.cutAdd.content.formData.normalz.show = false;
      } else {
        // this.cutTitle = "编辑方案";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/index.scss";
.el-scrollbar__bar.is-vertical {
  width: 6px;
  top: 2px;
}
.el-scrollbar__bar {
  position: absolute;
  right: 2px;
  bottom: 2px;
  z-index: 1;
  border-radius: 4px;
  opacity: 0;
  transition: opacity 120ms ease-out;
}
.treeShape {
  background: none;
  @include elTreeNode2();
  max-height: initial;
  min-height: 100px;
}

.table {
  @include box_wh(320, 0);
  height: auto;
  // max-height: 500px;
  padding: 0;
  transition-property: max-height, width, overflow;
  transition-duration: 0.3s, 0.3s, 0.3s;
}
.foot-operate {
  padding: 10px 10px;
  border-top: 1px solid rgba(245, 245, 245, 0.6) !important;
  justify-content: flex-end;
  align-items: center;
  display: flex;
  /deep/ .el-button {
    margin: 0;
    font-size: 14px;
    padding: 3px 10px;
    line-height: inherit;
    height: auto;
  }
}
</style>
